function Customer() {
  return (
    <div className="px-[20px] lg:px-[150px]">
      <h1>주요고객</h1>
    </div>
  );
}
export default Customer;
